import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getHotLeadList = createAsyncThunk(
    "getHotLeadList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/lead/remark-hot-lead-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const HotLeadSlice = createSlice({
    name: "HotLeadSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getHotLeadList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getHotLeadList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getHotLeadList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default HotLeadSlice.reducer;
